// import { motion } from "framer-motion";
// import MatchTime from "./MatchTime";
// import { formatCustomDate, formatTime } from "../util/dateUtils"; // adjust path
// import proxyImage from "../util/imageProxy";
// import { BookOpenIcon } from "@heroicons/react/24/solid";

// const UpcomingMatchesCard = ({
//   cardType,
//   gameData,
//   index,
//   isFakeUser,
//   isFirst = false,
//   isLast = false,
//   isToday = false,
// }) => {
//   return (
//     <div key={index} className="px-1 md:px-14 w-full">
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         exit={{ opacity: 0, y: -20 }}
//         transition={{ duration: 0.4 }}
// className={`shadow-lg text-white p-3 sm:p-4 md:p-6 text-center space-y-2 sm:space-y-2
//   ${
//     isFirst && isLast
//       ? "rounded-b-xl rounded-t-none"
//       : isFirst
//         ? "rounded-t-none rounded-b-none"
//         : isLast
//           ? "rounded-b-xl rounded-t-none"
//           : "rounded-none"
//   }`}
// style={{
//   background: `linear-gradient(to right, ${
//     gameData.TEAM1_COLOR || "#111"
//   }99, ${gameData.TEAM2_COLOR || "#000"}99)`,
// }}
//       >
//         {/* SERIES NAME */}
//         <h2 className="w-full italic text-center font-bold tracking-wide leading-tight text-[12px] sm:text-sm md:text-base lg:text-lg mb-0">
//           {gameData.SERIES_NAME}
//         </h2>

//         {/* TEAM + MATCH INFO ROW */}
//         <div className="flex items-center justify-around w-full">
//           {/* Team 1 */}
//           {!isFakeUser && (
//             <div className="text-center w-[30%] sm:w-[25%]">
//               <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full bg-gray-700 flex items-center justify-center mx-auto overflow-hidden">
//                 <img
//                   src={
//                     !isFakeUser
//                       ? proxyImage(gameData.TEAM1IMAGE)
//                       : gameData.TEAM1IMAGE
//                   }
//                   alt={gameData.TEAM1}
//                   className="w-full h-full object-contain"
//                 />
//               </div>
//               <p
//                 className="mt-1 font-medium"
//                 style={{
//                   fontSize: `clamp(0.6rem, ${Math.min(
//                     1 / gameData.TEAM1.length,
//                     1,
//                   )}rem, 1rem)`,
//                 }}
//               >
//                 {gameData.TEAM1}
//               </p>
//             </div>
//           )}

//           {/* Match Info */}
//           {!isFakeUser ? (
//             <div className="text-center flex-grow font-semibold text-white">
//               <div className="flex flex-col justify-center">
//                 {/* Compact info for mobile */}
//                 <div className="block md:hidden leading-tight space-y-0.5">
//                   <p className="text-[11px] sm:text-[13px] font-semibold">
//                     {gameData.GAME_INFO} Match - {gameData.GAME_TYPE}
//                   </p>
//                   <p className="text-[11px] sm:text-[13px] font-semibold">
//                     {formatTime(gameData.datetime)}
//                   </p>
//                 </div>

//                 {/* Larger screen info */}
//                 <p className="hidden md:block text-sm font-semibold mb-1">
//                   {gameData.GAME_INFO} Match - {gameData.GAME_TYPE} -{" "}
//                   {formatCustomDate(gameData.datetime)}
//                 </p>
//               </div>

//               {/* Match Time / Status */}
//               {/* <div className="scale-90 sm:scale-100">
//                 <MatchTime
//                   gameDate={gameData.GAME_DATE}
//                   gameTime={gameData.GAME_TIME}
//                   designType={2}
//                 />
//               </div> */}
//               {isToday && (
//                 <div className="scale-90 sm:scale-100">
//                   <MatchTime
//                     gameDate={gameData.GAME_DATE}
//                     gameTime={gameData.GAME_TIME}
//                     designType={2}
//                   />
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="text-center flex-grow font-semibold text-white">
//               <div className="flex flex-col justify-center">
//                 {/* MOBILE ONLY */}
//                 <div className="block md:hidden leading-tight space-y-0.5 mx-auto">
//                   {/* GAME INFO */}
//                   <div className="flex items-center justify-center gap-2">
//                     <span className="w-4 flex justify-center">
//                       <BookOpenIcon className="w-4 h-4" />
//                     </span>
//                     <p className="text-[12px] font-bold sm:text-[13px] text-left">
//                       {gameData.GAME_INFO}
//                     </p>
//                   </div>

//                   {/* TOPICS */}
//                   {gameData.GAME_TYPE.split(",").map((item, i) => (
//                     <div
//                       key={i}
//                       className="flex items-start justify-center gap-2"
//                     >
//                       {/* Fixed width icon column */}
//                       {/* <span className="w-4 flex justify-center">📍</span> */}

//                       {/* Text column always aligned */}
//                       <p className="text-[11px] sm:text-[13px] font-semibold text-left">
//                         {item.trim()}
//                       </p>
//                     </div>
//                   ))}
//                 </div>

//                 {/* DESKTOP ONLY */}
//                 <div className="hidden md:block leading-tight space-y-0.5 mx-auto">
//                   {/* GAME INFO */}
//                   <div className="flex items-center justify-center gap-2">
//                     <span className="w-4 flex justify-center">
//                       <BookOpenIcon className="w-4 h-4" />
//                     </span>
//                     <p className="text-[12px] font-bold sm:text-[13px] text-left">
//                       {gameData.GAME_INFO}
//                     </p>
//                   </div>

//                   {/* TOPICS */}
//                   {gameData.GAME_TYPE.split(",").map((item, i) => (
//                     <div
//                       key={i}
//                       className="flex items-start justify-center gap-2"
//                     >
//                       {/* <span className="w-4 flex justify-center">📍</span> */}
//                       <p className="text-[11px] sm:text-[13px] font-semibold text-left">
//                         {item.trim()}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Team 2 */}
//           {!isFakeUser && (
//             <div className="text-center w-[30%] sm:w-[25%]">
//               <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-full bg-gray-700 flex items-center justify-center mx-auto overflow-hidden">
//                 <img
//                   src={
//                     !isFakeUser
//                       ? proxyImage(gameData.TEAM2IMAGE)
//                       : gameData.TEAM2IMAGE
//                   }
//                   alt={gameData.TEAM2}
//                   className="w-full h-full object-contain"
//                 />
//               </div>
//               <p
//                 className="mt-1 font-medium"
//                 style={{
//                   fontSize: `clamp(0.6rem, ${Math.min(
//                     1 / gameData.TEAM2.length,
//                     1,
//                   )}rem, 1rem)`,
//                 }}
//               >
//                 {gameData.TEAM2}
//               </p>
//             </div>
//           )}
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default UpcomingMatchesCard;

// -----------------------------------

// import { motion } from "framer-motion";
// import { formatCustomTime } from "../util/dateUtils";
// import proxyImage from "../util/imageProxy";
// import { BookOpenIcon } from "@heroicons/react/24/solid";

// const UpcomingMatchesCard = ({
//   cardType,
//   gameData,
//   index,
//   isFakeUser,
//   isFirst = false,
//   isLast = false,
//   isToday = false,
// }) => {
//   return (
//     <div key={index} className="px-1 md:px-14 w-full">
//       <motion.div
//         initial={{ opacity: 0, y: 18 }}
//         animate={{ opacity: 1, y: 0 }}
//         exit={{ opacity: 0, y: -18 }}
//         transition={{ duration: 0.35 }}
//         className={`
//           relative overflow-hidden
//           text-white
//           px-3 py-2.5
//           sm:px-4 sm:py-3
//           md:px-5 md:py-4
//           backdrop-blur-md
//           shadow-[0_4px_18px_rgba(0,0,0,0.12)]
//           transition-all duration-300
//           hover:scale-[1.003]
//     ${
//       isFirst && isLast
//         ? "rounded-b-2xl rounded-t-none"
//         : isFirst
//           ? "rounded-t-none rounded-b-none"
//           : isLast
//             ? "rounded-b-2xl rounded-t-none"
//             : "rounded-none"
//     }
//   `}
//         style={{
//           background: `
//           linear-gradient(
//             135deg,
//             ${gameData.TEAM1_COLOR || "#111"}75,
//             ${gameData.TEAM2_COLOR || "#000"}75
//           )`,
//         }}
//       >
//         {/* Soft Glow Background */}
//         {/* <div className="absolute inset-0 bg-white/[0.03] pointer-events-none" /> */}

//         {/* Fake User Layout */}
//         {isFakeUser ? (
//           <div className="relative z-10 flex flex-col justify-center items-center text-center space-y-3">
//             {/* Game Info */}
//             <div className="flex items-center justify-center gap-2">
//               <BookOpenIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white/90" />

//               <h2 className="font-black uppercase tracking-wide text-sm sm:text-base md:text-lg">
//                 {gameData.GAME_INFO}
//               </h2>
//             </div>

//             {/* Topics */}
//             <div className="space-y-1">
//               {gameData.GAME_TYPE.split(",").map((item, i) => (
//                 <p
//                   key={i}
//                   className="text-xs sm:text-sm md:text-base font-semibold text-white/90"
//                 >
//                   {item.trim()}
//                 </p>
//               ))}
//             </div>
//           </div>
//         ) : (
//           <div className="relative z-10 flex items-center justify-between gap-2 sm:gap-4">
//             {/* TEAM 1 */}
//             <div className="flex flex-col items-center w-[26%] sm:w-[24%]">
//               <div
//                 className="
//                   w-12 h-12
//                   sm:w-16 sm:h-16
//                   md:w-20 md:h-20
//                   rounded-full
//                   bg-white/10
//                   backdrop-blur-xl
//                   // border border-white/10
//                   flex items-center justify-center
//                   overflow-hidden
//                   shadow-lg
//                 "
//               >
//                 <img
//                   src={proxyImage(gameData.TEAM1IMAGE)}
//                   alt={gameData.TEAM1}
//                   className="w-full h-full object-contain p-1"
//                 />
//               </div>

//               <p
//                 className="
//                   mt-1.5
//                   text-center
//                   font-medium
//                   tracking-[0.01em]
//                   leading-snug
//                   text-[10px]
//                   sm:text-xs
//                   md:text-sm
//                   lg:text-[15px]
//                   text-white/90
//                   antialiased
//                   break-words
//                   drop-shadow-[0_1px_1px_rgba(0,0,0,0.12)]
//                 "
//               >
//                 {gameData.TEAM1}
//               </p>
//             </div>

//             {/* CENTER CONTENT */}
//             <div className="flex-1 text-center px-1 sm:px-3">
//               {/* SERIES */}
//               <h2
//                 className="
//                   font-semibold
//                   uppercase
//                   tracking-[0.08em]
//                   leading-snug
//                   text-[11px]
//                   sm:text-sm
//                   md:text-base
//                   lg:text-lg
//                   text-white/90
//                   antialiased
//                   drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]
//                 "
//               >
//                 {gameData.SERIES_NAME}
//               </h2>

//               {/* Match Info */}
//               <div
//                 className="
//                   mt-2
//                   flex
//                   items-center
//                   justify-center
//                   gap-2
//                   flex-wrap
//                   text-center
//                 "
//               >
//                 <p
//                   className="
//                     font-medium
//                     text-[10px]
//                     sm:text-xs
//                     md:text-sm
//                     text-white/90
//                     tracking-[0.01em]
//                   "
//                 >
//                   {gameData.GAME_INFO} • {gameData.GAME_TYPE}
//                 </p>

//                 <span className="text-white/40 text-[10px] sm:text-xs md:text-sm">
//                   •
//                 </span>

//                 <p
//                   className="
//                     text-[10px]
//                     sm:text-xs
//                     md:text-sm
//                     font-medium
//                     tracking-[0.02em]
//                     text-white/85
//                   "
//                 >
//                   {formatCustomTime(gameData.datetime)}
//                 </p>
//               </div>
//             </div>

//             {/* TEAM 2 */}
//             <div className="flex flex-col items-center w-[26%] sm:w-[24%]">
//               <div
//                 className="
//                   w-12 h-12
//                   sm:w-16 sm:h-16
//                   md:w-20 md:h-20
//                   rounded-full
//                   bg-white/10
//                   backdrop-blur-xl
//                   border border-white/10
//                   flex items-center justify-center
//                   overflow-hidden
//                   shadow-lg
//                 "
//               >
//                 <img
//                   src={proxyImage(gameData.TEAM2IMAGE)}
//                   alt={gameData.TEAM2}
//                   className="w-full h-full object-contain p-1"
//                 />
//               </div>

//               <p
//                 className="
//                   mt-1.5
//                   text-center
//                   font-medium
//                   tracking-[0.01em]
//                   leading-snug
//                   text-[10px]
//                   sm:text-xs
//                   md:text-sm
//                   lg:text-[15px]
//                   text-white/90
//                   antialiased
//                   break-words
//                   drop-shadow-[0_1px_1px_rgba(0,0,0,0.12)]
//                 "
//               >
//                 {gameData.TEAM2}
//               </p>
//             </div>
//           </div>
//         )}
//       </motion.div>
//     </div>
//   );
// };

// export default UpcomingMatchesCard;
// -------Test

import { motion } from "framer-motion";
import { formatCustomTime } from "../util/dateUtils";
import proxyImage from "../util/imageProxy";
import { BookOpenIcon } from "@heroicons/react/24/solid";
import WeatherIcon from "./WeatherIcon";

const getWeatherIcon = (code) => {
  switch (code) {
    case "Clear":
      return "☀️";
    case "PartlyCloudy":
      return "⛅";
    case "Cloudy":
      return "☁️";
    case "Rain":
      return "🌧️";
    case "Snow":
      return "❄️";
    case "Thunderstorm":
      return "⛈️";
    case "Fog":
      return "🌫️";
    default:
      return "🌤️";
  }
};

const weatherAnimation = {
  Clear: {
    rotate: [-8, 8, -8],
    scale: [1, 1.08, 1],
  },
  PartlyCloudy: {
    x: [-2, 2, -2],
    y: [0, -2, 0],
  },
  Cloudy: {
    x: [-3, 3, -3],
  },
  Rain: {
    y: [0, 2, 0],
  },
  Thunderstorm: {
    rotate: [-10, 10, -10],
    scale: [1, 1.12, 1],
  },
};

const UpcomingMatchesCard = ({
  cardType,
  gameData,
  index,
  isFakeUser,
  isFirst = false,
  isLast = false,
  isToday = false,
}) => {
  const weather = gameData.WEATHER;

  return (
    <div key={index} className="px-1 md:px-14 w-full">
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -18 }}
        transition={{ duration: 0.35 }}
        className={`relative overflow-hidden text-white px-3 pt-2.5 pb-2.5 sm:px-4 sm:py-3 md:px-5 md:py-4 backdrop-blur-md shadow-[0_4px_18px_rgba(0,0,0,0.12)] transition-all duration-300 hover:scale-[1.003]
        ${
          isFirst && isLast
            ? "rounded-b-2xl rounded-t-none"
            : isFirst
              ? "rounded-t-none rounded-b-none"
              : isLast
                ? "rounded-b-2xl rounded-t-none"
                : "rounded-none"
        }`}
        style={{
          background: `linear-gradient(135deg, ${gameData.TEAM1_COLOR || "#111"}75, ${gameData.TEAM2_COLOR || "#000"}75)`,
        }}
      >
        {isFakeUser ? (
          <div className="relative z-10 flex flex-col justify-center items-center text-center space-y-3">
            <div className="flex items-center justify-center gap-2">
              <BookOpenIcon className="w-4 h-4 sm:w-5 sm:h-5 text-white/90" />
              <h2 className="font-black uppercase tracking-wide text-sm sm:text-base md:text-lg">
                {gameData.GAME_INFO}
              </h2>
            </div>
            <div className="space-y-1">
              {gameData.GAME_TYPE.split(",").map((item, i) => (
                <p
                  key={i}
                  className="text-xs sm:text-sm md:text-base font-semibold text-white/90"
                >
                  {item.trim()}
                </p>
              ))}
            </div>
          </div>
        ) : (
          <>
            <div className="relative z-10 flex items-center justify-between gap-2 sm:gap-4">
              <div className="flex flex-col items-center w-[26%] sm:w-[24%]">
                <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-white/10 backdrop-blur-xl flex items-center justify-center overflow-hidden shadow-lg">
                  <img
                    src={proxyImage(gameData.TEAM1IMAGE)}
                    alt={gameData.TEAM1}
                    className="w-full h-full object-contain p-1"
                  />
                </div>
                <p className="mt-1.5 text-center font-medium text-[10px] sm:text-xs md:text-sm lg:text-[15px] text-white/90 break-words">
                  {gameData.TEAM1}
                </p>
              </div>

              <div className="flex-1 text-center px-1 sm:px-3">
                <h2 className="font-semibold uppercase tracking-[0.08em] text-[11px] sm:text-sm md:text-base lg:text-lg text-white/90">
                  {gameData.SERIES_NAME}
                </h2>

                {/* <div className="mt-2 flex items-center justify-center gap-2 flex-wrap">
                  <p className="font-medium text-[10px] sm:text-xs md:text-sm text-white/90">
                    {gameData.GAME_INFO} • {gameData.GAME_TYPE}
                  </p>
                  <span className="text-white/40">•</span>
                  <p className="font-medium text-[10px] sm:text-xs md:text-sm text-white/85">
                    {formatCustomTime(gameData.datetime)}
                  </p>
                </div> */}

                <div className="mt-2 flex items-center justify-center gap-2 flex-wrap">
                  <p className="font-medium text-[10px] sm:text-xs md:text-sm text-white/90">
                    <span className="hidden sm:inline">
                      {gameData.GAME_INFO}
                      <span className="mx-2 inline-block h-3 w-px bg-white/30 align-middle" />
                    </span>
                    {gameData.GAME_TYPE}
                  </p>

                  <span className="h-3 w-px bg-white/30" />

                  <p className="font-medium text-[10px] sm:text-xs md:text-sm text-white/85">
                    {formatCustomTime(gameData.datetime)}
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center w-[26%] sm:w-[24%]">
                <div className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full bg-white/10 backdrop-blur-xl border border-white/10 flex items-center justify-center overflow-hidden shadow-lg">
                  <img
                    src={proxyImage(gameData.TEAM2IMAGE)}
                    alt={gameData.TEAM2}
                    className="w-full h-full object-contain p-1"
                  />
                </div>
                <p className="mt-1.5 text-center font-medium text-[10px] sm:text-xs md:text-sm lg:text-[15px] text-white/90 break-words">
                  {gameData.TEAM2}
                </p>
              </div>
            </div>

            {weather && (
              <div className="relative z-10 mt-2.5 pt-2 border-t border-white/10 w-full">
                <motion.div
                  // 1. Removed flex-wrap, reduced mobile gap to 1.5 (6px)
                  className="flex items-center justify-center gap-1.5 sm:gap-3 w-full"
                  initial="hidden"
                  animate="visible"
                  variants={{
                    hidden: { opacity: 0 },
                    visible: {
                      opacity: 1,
                      transition: {
                        staggerChildren: 0.1, // Staggers the animation of each pill
                      },
                    },
                  }}
                >
                  {/* Condition Pill */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, y: 10 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    whileHover={{ scale: 1.05 }}
                    // 2. Reduced mobile padding (px-1.5 py-1), font size (text-[11px]), and added whitespace-nowrap
                    className="flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-3 py-1 sm:py-1.5 text-white/90 text-[11px] sm:text-xs md:text-sm font-medium whitespace-nowrap"
                  >
                    <WeatherIcon condition={weather.conditionCode} />
                    <span className="tracking-wide">
                      {weather.conditionCode.replace(/([A-Z])/g, " $1").trim()}
                    </span>
                  </motion.div>

                  {/* Temperature Pill */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, y: 10 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    whileHover={{ scale: 1.05 }}
                    className="flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-3 py-1 sm:py-1.5 text-white/90 text-[11px] sm:text-xs md:text-sm whitespace-nowrap"
                  >
                    <span className="text-[12px] sm:text-[14px]">🌡️</span>
                    <span className="font-semibold">
                      {Math.round(weather.temperature)}°C
                    </span>
                  </motion.div>

                  {/* Feels Like Pill (Hidden on extra small screens) */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, y: 10 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    whileHover={{ scale: 1.05 }}
                    className="hidden md:flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-3 py-1 sm:py-1.5 text-white/90 text-[11px] sm:text-xs md:text-sm whitespace-nowrap"
                  >
                    <span className="text-[12px] sm:text-[14px]">🤚</span>
                    <span>
                      Feels {Math.round(weather.temperatureApparent)}°C
                    </span>
                  </motion.div>

                  {/* Humidity Pill */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, y: 10 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    whileHover={{ scale: 1.05 }}
                    className="hidden md:flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-3 py-1 sm:py-1.5 text-white/90 text-[11px] sm:text-xs md:text-sm whitespace-nowrap"
                  >
                    <span className="text-[12px] sm:text-[14px]">💧</span>
                    <span>{Math.round(weather.humidity * 100)}%</span>
                  </motion.div>

                  {/* Wind Speed Pill */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, y: 10 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    whileHover={{ scale: 1.05 }}
                    className="flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-3 py-1 sm:py-1.5 text-white/90 text-[11px] sm:text-xs md:text-sm whitespace-nowrap"
                  >
                    <span className="text-[12px] sm:text-[14px]">💨</span>
                    <span>{Math.round(weather.windSpeed)} km/h</span>
                  </motion.div>

                  {/* Precipitation Pill */}
                  <motion.div
                    variants={{
                      hidden: { opacity: 0, y: 10 },
                      visible: { opacity: 1, y: 0 },
                    }}
                    whileHover={{ scale: 1.05 }}
                    className="flex items-center gap-1 sm:gap-1.5 px-1.5 sm:px-3 py-1 sm:py-1.5 text-white/90 text-[11px] sm:text-xs md:text-sm whitespace-nowrap"
                  >
                    <span className="text-[12px] sm:text-[14px]">🌧</span>
                    <span>
                      {Math.round(weather.precipitationChance * 100)}%
                    </span>
                  </motion.div>
                </motion.div>
              </div>
            )}
          </>
        )}
      </motion.div>
    </div>
  );
};

export default UpcomingMatchesCard;
